import { USER_FORM, AccessType } from '../form-portaluser-type';
import GetPartnerData from './areas/get-partner-data';
import GetCustomerData from './areas/get-customer-data';
import GetTerminalData from './areas/get-terminal-data';
import GetCardGroupData from './areas/get-card-group-data';

import useAuth from '../../../../hooks/auth-hooks';

/**
 * Function that displays an area that will allow items to be associated with a certain role.
 * 
 * @param {string} listText the type of access { Customer, Portner, Terminal, Card Group}
 */
const DisplayAccessArea = (listText: AccessType) => {
  USER_FORM.userAccessContainer.innerHTML = '';

  const { accessType } = useAuth()!;

  const divListWidget = document.createElement('div');
  divListWidget.className = 'aafp_terminal-card aafp_border-radius';

  const divFormRow = document.createElement('div');
  divFormRow.className = 'form-row';

  const divColLeft = document.createElement('div');
  divColLeft.className = 'col-md-6';

  const divColLeftCon = document.createElement('div');
  divColLeftCon.style.display = 'flex';
  divColLeftCon.style.fontSize = '1.2rem';

  const divListCon = document.createElement('div');
  divListCon.className = 'aafp_text-field';

  const searchInput = document.createElement('input');
  searchInput.placeholder = `Search for ${listText}`;
  searchInput.className = 'aafp_input aafp_color-theme-input';
  searchInput.id = 'aafp_customer-input';
  searchInput.type = 'text';

  const searchClear = document.createElement('span');
  searchClear.className = 'aafp_clear-search';

  const searchClearIcon = document.createElement('i');
  searchClearIcon.className = 'fas fa-times';

  const listAval = document.createElement('div');
  listAval.className = `aafp_list-result-container aafp_border-radius`;
  listAval.innerText = `Retrieving ${listText} list.. `;

  const divColRight = document.createElement('div');
  divColRight.className = 'col-md-6';

  const divColRightHeader = document.createElement('h4');
  divColRightHeader.className = 'aafp_customer-text';
  divColRightHeader.innerText = `Current ${listText} Access:`;

  const linkedList = document.createElement('div');
  if ( listText == 'Card Group' ) {
    linkedList.className = `aafp_card-group-container linked-list aafp_card-group-container`;
  } else {
    linkedList.className = `aafp_${listText.toLowerCase()}-container linked-list`;
  }

  divListWidget.appendChild(divFormRow);
  if ( accessType != 'R') {
    divFormRow.appendChild(divColLeft);
    divColLeft.appendChild(divColLeftCon);
    divColLeftCon.appendChild(divListCon);
    divListCon.appendChild(searchInput);
    divListCon.appendChild(searchClear);
    searchClear.appendChild(searchClearIcon);
    divColLeft.appendChild(listAval);
  }

  divFormRow.appendChild(divColRight);
  divColRight.appendChild(divColRightHeader);
  divColRight.appendChild(linkedList);

  USER_FORM.userAccessContainer.appendChild(divListWidget);

  setTimeout(() => {
    switch( listText ) {
      case 'Partner':
        GetPartnerData();
        break;
      case 'Customer':
        GetCustomerData();
        break;
      case 'Terminal':
        GetTerminalData();
        break;
      case 'Card Group':
        GetCardGroupData();
        break;
    }
  }, 0);
}

export default DisplayAccessArea;